import * as React from 'react';

import { Binding } from 'core/infrastructure';
import { cloneExcept, DateUtils } from '../../utils';
import { FormComponent } from './Form';
import { Constraint } from './Constraints';
import { TextBox, TextBoxCtor } from './TextBox';

import { startOfDay, isEqual } from 'date-fns';


interface Props<T> extends React.DetailedHTMLProps<React.InputHTMLAttributes<DateTimeBox<T>>, DateTimeBox<T>> {
	linkTo: Binding.PropertyPath<T>;
	label?: string | React.ReactNode;
	rules?: Constraint | Constraint[];
	onEnterPress?: () => void;
	onValueChange?: (value: string) => void;
	boundValue?: any;
}

export class DateTimeBox<T> extends React.Component<Props<T>, EmptyState> implements FormComponent {

	constructor(props: Props<T>) {
		super(props);
	}

	private textBox = React.createRef<TextBox<T>>();

	getPath() {
		return this.textBox.current!.getPath();
	}

	showErrors(errors: string[]) {
		this.textBox.current!.showErrors(errors);
	}

	getValue() {
		return this.textBox.current!.getValue();
	}

	render() {
		const TheTextBox: TextBoxCtor<T> = TextBox;

		const props = cloneExcept(this.props, ['ref', 'allowNegative']);
		props.rules = !props.rules ? [] : typeof props.rules === 'function' ? [props.rules] : props.rules;

		props.propertyType = 'date';
		props.type = 'text';

		props.format = (x?: Date) => {
			if (!x)
				return '';
			const isOnlyDate = isEqual(startOfDay(x), x);
			return isOnlyDate ? DateUtils.formatDate(x, 'dd/MM/yyyy') : DateUtils.formatDate(x, 'dd/MM/yyyy HH:mm');
		};

		props.placeholder = props.placeholder || 'dd/mm/aaaa hh:mm';

		return <TheTextBox ref={this.textBox} {...props} />;
	}
}

export type DateTimeBoxCtor<T> = new (props: Props<T>) => DateTimeBox<T>;
